"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class DeliveryMethodOnlinePolicy extends Policy_1.Policy {
    meets(criteria) {
        var _a, _b;
        return ((_a = criteria.deliveryMethod) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "online"
            || ((_b = criteria.deliveryMethod) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) === "blended";
    }
}
exports.default = new DeliveryMethodOnlinePolicy();
